@if (conv$ | async; as conv) {
  @if (view$ | async; as view) {
    <span cdkOverlayOrigin
      #origin="cdkOverlayOrigin"
      class="origin"
    [innerHTML]="(view === 'local' ? conv.local : conv.utc) | moment:format"></span>
    <i class="origin-zone">{{(view === 'local' ? conv.local : conv.utc) | moment:'Z'}}</i>
    <ng-template cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="origin"
      [cdkConnectedOverlayOpen]="showOverlay$ | async">
      <div class="zoned-tooltip">
        <table class="conversions">
          <tr>
            <th class="zoned-tooltip-head"
              colspan="3">Time conversion
            </th>
          </tr>
          @if (conv.local) {
            <tr>
              <td class="zone">Local • {{conv.local | moment:'z'}}</td>
              <td class="time">{{conv.local | moment:'LT'}}</td>
              <td class="date">{{conv.local | moment: 'MMM D, YYYY'}}</td>
            </tr>
          }
          <tr>
            <td class="zone">{{conv.utc | moment:'z'}}</td>
            <td class="time">{{conv.utc | moment:'LT'}}</td>
            <td class="date">{{conv.utc | moment: 'MMM D, YYYY'}}</td>
          </tr>
          <!--        <tr>-->
          <!--          <td class="zone">{{conv.guess | moment:'z'}} • Your computer</td>-->
          <!--          <td class="time">{{conv.guess | moment:'LT'}}</td>-->
          <!--          <td class="date">{{conv.guess | moment: 'MMM D, YYYY'}}</td>-->
        <!--        </tr>-->
      </table>
    </div>
  </ng-template>
}
}
